<template>
  <v-container fluid>
    <v-row>
      <!-- main -->
      <v-col>
        <wapi-panel :title="'Управление пользователями'">
          <template v-slot:content>
            <UsersList :model="users" />
          </template>
        </wapi-panel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WapiContract from "../models/contract/WapiContract";
import { areaInKm2 } from "../helpers/common";
import UsersList from "../components/UserList.vue";
import WapiPanel from "../components/WapiPanel";

export default {
  name: "UsersView",
  title: "Клиенты",
  components: {
    UsersList,
    WapiPanel
  },
  async mounted() {
    await this.$store.dispatch("FETCH_USERS");
    this.users = this.$store.getters.USERS;
  },
  data: function() {
    return {
      page: 1,
      paginationTotalVisible: 10,
      perPage: 6,
      pvariants: [],
      dvariant: null,
      presets: [],
      contractModel: new WapiContract(),
      geoJsonOptions: {
        onEachFeature: (feature, layer) => {
          const bounds = layer.getBounds();
          layer.getLatLng = function() {
            return this.getBounds().getCenter();
          };
          layer.setLatLng = function() {};
          layer._latlng = layer.getLatLng();
          const mapId = this.pagePresets.findIndex(
            x => x.area.id === feature.id
          );
          this.$refs.maps[mapId].mapObject.fitBounds(bounds);
        }
      },
      dvariants: [],
      predicts: [],
      users: [],
      userId: "",
      presetId: "",
      result: [],
      user: {}
    };
  },
  computed: {
    paginationLength() {
      return Math.ceil(this.presets.length / this.perPage);
    },
    pagePresets() {
      const from = (this.page - 1) * this.perPage;
      const to = this.page * this.perPage;
      return this.presets.slice(from, to);
    },
    pagination() {
      return !!this.pagePresets.length;
    },
    userName() {
      if (!this.userId) return "";
      return this.users.find(x => x.id === this.userId).name;
    },
    totalAreaInKm() {
      const reducer = (accumulator, currentValue) =>
        accumulator +
        Math.round(areaInKm2(currentValue.area.geometry) / 1000000);
      return this.pagePresets.reduce(reducer, 0);
    },
    totalAreaInHa() {
      const reducer = (accumulator, currentValue) =>
        accumulator + Math.round(areaInKm2(currentValue.area.geometry) / 10000);
      return this.pagePresets.reduce(reducer, 0);
    }
  },
  methods: {
    areaInKm(geojson) {
      const area = Math.round(areaInKm2(geojson.geometry) / 1000000);
      return area;
    },
    areaInHa(geojson) {
      const area = Math.round(areaInKm2(geojson.geometry) / 10000);
      return area;
    },
    openPreset(preset) {
      this.$router.push({
        name: "presetDetails",
        params: { userId: preset.user_id, presetId: preset.id }
      });
    },
    deletePreset() {},
    async onChangeUser() {
      await this.$store.dispatch("FETCH_PRESETS", this.userId);
      this.presets = this.$store.getters.PRESETS;

      await this.$store.dispatch("FETCH_CONTRACTS");
      this.contractModel = this.$store.getters.CONTRACT_BY_USERID(this.userId);
      const max = Math.min(
        ...this.contractModel.dvariants.map(d => d.prioritet)
      );
      this.dvariant = this.contractModel.dvariants.find(
        d => d.prioritet === max
      );
      this.predicts = this.dvariant.predicts;
      this.pvariants = this.contractModel.pvariants;
      this.reset();
    },
    async onChangePreset() {
      const preset = this.presets.find(p => p.id === this.presetId);
      this.geojson = preset.area;
    },
    reset() {
      this.page = 1;
    }
  }
};
</script>